import { NavLink, useLocation } from "react-router-dom";
import { Home, UtensilsCrossed, LineChart, MoreHorizontal } from "lucide-react";

/* ════════════════════════════════════════════════════════════════════════
   PROJECT WHĀNAU OS — MOBILE BOTTOM TAB NAV
   Glassmorphic, fixed-bottom on screens < lg. Shows on authenticated app
   surfaces only (skipped on /login, /register, marketing pages, /home-os/wall).
   ════════════════════════════════════════════════════════════════════════ */

const PUBLIC_PATHS = [
  "/", "/login", "/register",
  "/how-it-works", "/pricing", "/about", "/contact", "/join-beta", "/legacy-landing",
  "/security", "/security/open-banking", "/privacy", "/terms",
  "/invite/accept", "/invite/decline",
  "/action/approve", "/action/decline",
];

const TABS = [
  { to: "/home-os",       label: "Today",  Icon: Home,             testId: "whanau-bottom-tab-today",  match: (p) => p === "/home-os" || p.startsWith("/home-os/") && !p.startsWith("/home-os/meals") && !p.startsWith("/home-os/wall") },
  { to: "/home-os/meals", label: "Meals",  Icon: UtensilsCrossed,  testId: "whanau-bottom-tab-meals",  match: (p) => p.startsWith("/home-os/meals") },
  { to: "/dashboard",     label: "Money",  Icon: LineChart,        testId: "whanau-bottom-tab-money",  match: (p) => p === "/dashboard" || p.startsWith("/transactions") || p.startsWith("/bills") || p.startsWith("/cycles") },
  { to: "/home-os/wall",  label: "More",   Icon: MoreHorizontal,   testId: "whanau-bottom-tab-more",   match: (p) => p.startsWith("/home-os/wall") || p.startsWith("/home-os/documents") || p.startsWith("/home-os/supplies") || p.startsWith("/home-os/mood") || p.startsWith("/home-os/cleaning") },
];

export function WhanauBottomNav() {
  const { pathname } = useLocation();
  // Hide on public/auth pages and on the Wall Display screensaver.
  if (PUBLIC_PATHS.includes(pathname)) return null;
  if (pathname.startsWith("/home-os/wall")) return null;

  return (
    <nav className="whanau-bottom-nav" aria-label="Primary mobile navigation" data-testid="whanau-bottom-nav">
      {TABS.map(({ to, label, Icon, testId, match }) => {
        const active = match(pathname);
        return (
          <NavLink
            key={to}
            to={to}
            aria-current={active ? "page" : undefined}
            data-testid={testId}
          >
            <Icon className="w-5 h-5" strokeWidth={active ? 2.5 : 2} aria-hidden />
            <span>{label}</span>
          </NavLink>
        );
      })}
    </nav>
  );
}

export default WhanauBottomNav;
